import { request } from '@/shared/api/request'

export const sendTo = (isEmployee = false, externalId) => {
	return request({ url: `/colcontract/ecd/sendTo/${externalId}?isEmployee=${isEmployee}`, method: 'POST' })
}
